import { useMemo } from 'react'

import { sortArrayBy } from '@domain-group/javascript-utils'

import { useWatchEntityUpdates } from '@domain-group/react-hooks'

import useReduxAction from '@hooks/useReduxAction'
import useSelector from '@hooks/useSelector'

import type { CampaignTypeRequestOptions } from '@models/types'
import type { ModuleState } from '@redux/modules/types'

const watchEntityKeys = ['campaignTypes']

type UseCampaignTypesOptions = {
  performHttpRequests?: boolean,
  requestOptions?: CampaignTypeRequestOptions,
}

function useCampaignTypes(options: UseCampaignTypesOptions) {
  const { performHttpRequests = false, requestOptions } = options

  const {
    updatedEntities: { campaignTypes: campaignTypesUpdatedAt },
  } = useWatchEntityUpdates(watchEntityKeys)

  const { campaignTypes } = useSelector(reduxState => reduxState.entities)

  const filteredCampaignTypes = useMemo(
    () => sortArrayBy(Object.values(campaignTypes), 'asc', 'title'),
    [campaignTypesUpdatedAt],
  )

  const filteredCampaignTypesCount = filteredCampaignTypes.length
  const hasFilteredCampaignTypes = !!filteredCampaignTypesCount

  const { loading: loadingCampaignTypes } = useReduxAction(
    'campaignTypes',
    'loadCampaignTypes',
    {
      ...requestOptions,
    },
    [performHttpRequests],
    {
      shouldPerformFn: ({ loading }: ModuleState) => performHttpRequests && !loading,
    },
  )

  return {
    filteredCampaignTypes,
    filteredCampaignTypesCount,
    hasFilteredCampaignTypes,
    loading: loadingCampaignTypes,
  }
}

export default useCampaignTypes
